export default "/moorETH-WETH-BPT.85ebfb30312c39c1a9f9f8107b7742f9.png";